import { useCallback, useMemo, useState, useEffect } from 'react'
import { Skeleton, Autocomplete, Grid, TextField, Typography } from '@mui/material'
import { getRequestConfig } from '../auth/auth'
import { ApiGateway } from '../config/config'
import { ROLES } from '../auth/role'
import axios from 'axios'

export default function QSEAutoComplete(props = { initializeDefaultUser: false, defaultUserId: undefined, onChange: undefined, label: undefined, placeholder: undefined, roles: [] | undefined }) {
  const [userList, setUserList] = useState([])
  const [userAcList, setUserAcList] = useState([])
  const [userId, setUserId] = useState('')
  const [loading, setLoading] = useState(false)
  // const loading = false
  const { onChange: onChangeFromProps, roles = [ROLES.QSE_MGR] } = props

  const loadUsers = useCallback(async () => {
    setLoading(true)
    const requestConfig = await getRequestConfig()
    const basePath = `${ApiGateway.user}/search`

    try {
      let qseData = []
      const _roles = (roles !== undefined) ? [...roles] : []
      _roles.push(ROLES.MFI_ADMIN)
      
      const workers = _roles.map((r) => axios.post(basePath, { roleId: r.id }, requestConfig))
      const responses = await Promise.all(workers)
      qseData = responses.flatMap((resp) => resp.data)
      
      setUserList(qseData)
      setUserAcList(qseData.filter(user => user.isActive !== false ))
    } catch (error) {
      setUserList([{label: 'unable to load data', value: '-1'}])
    }

    setLoading(false)
  }, [roles])

  useEffect(() => {
    loadUsers()
  }, [loadUsers])

  useEffect(() => {
    if(userList?.length) {
      if(props.defaultUserId) {
        const currentUser = userList.find(assessor => assessor.koId === props.defaultUserId)
        if(currentUser) {
          setUserId(currentUser.koId)
        }

        if(onChangeFromProps && props.initializeDefaultUser) {
          onChangeFromProps(props.defaultUserId)
        }
      } 
    }
  }, [userList, props.defaultUserId, onChangeFromProps, props.initializeDefaultUser])

  const user = useMemo(() =>
    userList.find(u => `${u.koId}` === `${userId}`) || null,
    [userList, userId]
  )

  return loading ? <Skeleton sx={{height: '37.8px'}}/> : <Autocomplete
    id="user"
    getOptionLabel={(option) => `${option?.firstName} ${option?.lastName} (${option?.koId})` || {}}
    filterOptions={(x) => x}
    options={userAcList}
    autoComplete
    size='small'
    filterSelectedOptions
    value={user}
    noOptionsText="No results"
    onChange={(event, newValue) => {
      setUserId(newValue?.koId)
      onChangeFromProps?.(newValue?.koId)
    }}
    onInputChange={(event, newInputValue) => {
      if (!newInputValue) {
        setUserAcList(userList.filter(user => user.isActive !== false ))
      } else {
        const newUserList = userList.filter(user => {
          const lowerInput = (newInputValue || "").toLowerCase();
          const firstName = (user.firstName || "").toLowerCase();
          const lastName = (user.lastName || "").toLowerCase();
          const koId = (user.koId || "").toLowerCase();
          return user.isActive !== false && (firstName.includes(lowerInput) || lastName.includes(lowerInput) || koId.includes(lowerInput))
        })
        setUserAcList(newUserList)
      }
    }}
    renderInput={(params) => (
      <TextField {...params} value={params.value || ''} label={props.label === false ? undefined : (props.label || 'QSE Manager')} fullWidth placeholder={props.placeholder === false ? undefined : (props.placeholder || 'QSE Manager')} />
    )}
    renderOption={(props, option) => {
      return (
        <li {...props} key={props.key}>
          <Grid container alignItems="center">
            <Grid item sx={{ width: 'calc(100% - 44px)', wordWrap: 'break-word' }}>
              <Typography variant="body2" color="text.secondary">
                {option?.firstName} {option?.lastName} ({option?.koId})
              </Typography>
            </Grid>
          </Grid>
        </li>
      );
    }}
  />
}